import "./InputPreview.scss"
import "./MessagePreview.scss"
import "./MessagesPreview.scss"
import "./MessengerPreview.scss"
import React from "react"
import { Icon, TeamIcon } from "../../../lib"
import ContactFormPreview from "./ContactFormPreview"
import PoweredByPreview from "./PoweredByPreview"
import MessagePreview from "./MessagePreview"

const MessengerPreview = ({
  prompt,
  entry,
  display,
  offlineGreeting,
  hideTeamIcon,
  hideLogo,
  colorStyle,
  contactEnabled,
  contactDismissible,
  contactPrompt,
  contactReply,
  contactFieldLabel,
  nameFieldLabel,
}) => {
  return (
    <div className="Messenger_messenger">
      <header className="Messenger_header" style={colorStyle}>
        {!hideTeamIcon && <TeamIcon className="Avatar" size={25} />}
        <h4 className="Messenger_prompt">{prompt}</h4>
        <Icon
          className="Messenger_close"
          color={colorStyle.color}
          name="close"
          type="legacy"
          size={20}
        />
      </header>
      <div className="Messenger_content">
        <div className="Messages">
          <div className="Messages_list">
            <MessagePreview message="Hello, World!" />
            {(display === "offline" ||
              display === "contact" ||
              display === "reply") && (
              <MessagePreview
                message={offlineGreeting}
                last={display !== "reply"}
                from="app"
              />
            )}
            {display === "contact" && (
              <ContactFormPreview
                contactEnabled={contactEnabled}
                contactDismissible={contactDismissible}
                contactPrompt={contactPrompt}
                contactFieldLabel={contactFieldLabel}
                nameFieldLabel={nameFieldLabel}
                colorStyle={colorStyle}
              />
            )}
            {display === "reply" && (
              <MessagePreview message={contactReply} from="app" />
            )}
          </div>
          {!hideLogo && <PoweredByPreview />}
        </div>
        <div className="Input">
          <textarea
            className="Input_field"
            placeholder={entry}
            rows={1}
            disabled
          />
          <button className="Input_button Input_button-emoji" disabled>
            <Icon name="emoji" size={18} type="legacy" />
          </button>
          <button className="Input_button Input_button-send" disabled>
            <Icon name="send" size={18} type="legacy" />
          </button>
        </div>
      </div>
    </div>
  )
}

MessengerPreview.displayName = "MessengerPreview"

export default MessengerPreview



// WEBPACK FOOTER //
// ./src/channel/appearance/preview/MessengerPreview.js